import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { ICON_CLOSE_WHITE, ICON_MAXIMIZE, ICON_MINIMIZE } from '@repo/assets';
import { FlexWrap, LoadingView } from '@repo/components';
import { ExpiringImage } from '../common/ExpiringImage';

type Props = {
  imgUrl: string;
  onTogglePreview?: () => void;
  onClose: () => void;
  /** 서명 URL 이 만료됐을 때 목록을 다시 받아오도록 알린다. */
  onExpired?: () => void;
};
export const ImagePreviewModal = ({
  imgUrl,
  onTogglePreview,
  onClose,
  onExpired,
}: Props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isRotate, setIsRotate] = useState(false);
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  // 실패했을 때도 로딩 표시를 걷어야 한다. 그러지 않으면 403 이 났을 때
  // 로딩 스피너가 멈추지 않는다.
  const handleImageError = () => {
    setIsLoading(false);
  };

  useEffect(() => {
    if (isRotate && scrollRef.current) {
      // 이미지 회전 후 스크롤 맨 위로 이동
      scrollRef.current.scrollLeft = scrollRef.current.scrollWidth;
    }
  }, [isRotate]);

  return (
    <BackContainer
      onClick={() => {
        document.body.style.removeProperty('overflow');
        if (onTogglePreview) {
          onTogglePreview();
        } else {
          onClose();
        }
      }}
    >
      {isRotate ? (
        <WrapperWrapper ref={scrollRef}>
          <VerticalWrapper>
            <VerticalImage
              src={imgUrl}
              onLoad={handleImageLoad}
              onError={handleImageError}
              onExpired={onExpired}
            />
            <RotateButton
              type='button'
              onClick={(e) => {
                e.stopPropagation();
                setIsRotate(!isRotate);
              }}
            >
              <img src={ICON_MINIMIZE} alt='' width={32} />
            </RotateButton>
          </VerticalWrapper>
        </WrapperWrapper>
      ) : (
        <HorizenWrapper>
          <HorizenImage
            src={imgUrl}
            onLoad={handleImageLoad}
            onError={handleImageError}
            onExpired={onExpired}
          />
          <RotateButton
            type='button'
            onClick={(e) => {
              e.stopPropagation();
              setIsRotate(!isRotate);
            }}
          >
            <img src={ICON_MAXIMIZE} alt='' width={32} />
          </RotateButton>
        </HorizenWrapper>
      )}
      <CloseImg src={ICON_CLOSE_WHITE} />
      {isLoading && <LoadingView />}
    </BackContainer>
  );
};

const BackContainer = styled(FlexWrap)`
  position: fixed;
  inset: 0 0 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0 20px;
  background-color: rgba(58, 59, 62, 0.8);
  z-index: 200;
`;

const HorizenWrapper = styled.div`
  position: relative;
  width: 335px;
  overflow: auto;
`;

const HorizenImage = styled(ExpiringImage)`
  display: block;
  width: 100%;
  height: 100%;
`;

const WrapperWrapper = styled.div`
  overflow: auto;
`;

const VerticalWrapper = styled.div`
  position: relative;
  transform: rotateZ(90deg);
  width: fit-content;
  height: fit-content;
  padding-bottom: 200px;
`;

const VerticalImage = styled(ExpiringImage)`
  display: block;
  width: 70vh;
`;

const RotateButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 999;
`;

const CloseImg = styled.img`
  position: fixed;
  top: 10px;
  right: 10px;
  cursor: pointer;
  width: 35px;
  height: 35px;
`;
